var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-provider-card" }, [
    _c("div", { staticClass: "c-provider-card__provider-details" }, [
      _c("span", { staticClass: "c-provider-card__img" }, [
        _vm.doctor.imageUrl
          ? _c("img", { attrs: { src: _vm.doctor.imageUrl } })
          : _c("span", { staticClass: "c-provider-card__img-no-image" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "105",
                    height: "110",
                    viewBox: "0 0 105 110",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d:
                        "M17.5441 0C18.8927 0 19.986 1.02601 19.986 2.29167V7.17343C20.0086 7.29874 20.0204 7.42751 20.0204 7.55885C20.0204 7.6902 20.0086 7.81897 19.986 7.94428V12.8639C19.986 14.1295 18.8927 15.1555 17.5441 15.1555C16.1955 15.1555 15.1023 14.1295 15.1023 12.8639V9.85052H4.88372V36.1772C4.88372 50.4031 17.4484 62.0178 33.0562 62.0178C48.664 62.0178 61.2287 50.4031 61.2287 36.1772V9.85052H50.9155V12.8639C50.9155 14.1295 49.8223 15.1555 48.4737 15.1555C47.1251 15.1555 46.0318 14.1295 46.0318 12.8639V2.29167C46.0318 1.02601 47.1251 0 48.4737 0C49.8223 0 50.9155 1.02601 50.9155 2.29167V5.26719H63.6705C65.0191 5.26719 66.1124 6.2932 66.1124 7.55885V36.1772C66.1124 52.148 52.7693 65.1788 35.8706 66.4922V80.1785C35.8706 94.0381 48.3205 105.417 63.8711 105.417C79.4218 105.417 91.8716 94.0381 91.8716 80.1785V68.5479C87.0889 67.5231 83.5296 63.4923 83.5296 58.6911C83.5296 53.1176 88.3259 48.5824 94.2648 48.5824C100.204 48.5824 105 53.1176 105 58.6911C105 63.4597 101.489 67.4682 96.7554 68.5266V80.1785C96.7554 96.7281 81.9467 110 63.8711 110C45.7956 110 30.9869 96.7281 30.9869 80.1785V66.5423C13.7369 65.5601 0 52.382 0 36.1772V7.55885C0 6.2932 1.09326 5.26719 2.44186 5.26719H15.1023V2.29167C15.1023 1.02601 16.1955 0 17.5441 0ZM94.2648 53.1657C91.0431 53.1657 88.4133 55.6301 88.4133 58.6911C88.4133 61.752 91.0431 64.2165 94.2648 64.2165C97.4865 64.2165 100.116 61.752 100.116 58.6911C100.116 55.6301 97.4865 53.1657 94.2648 53.1657Z",
                      fill: "#EBE0EB"
                    }
                  })
                ]
              )
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-provider-card__provider-info" }, [
        _c("div", { staticClass: "c-provider-card__header" }, [
          _c("h3", { staticClass: "item__name" }, [
            _c("a", { attrs: { href: _vm.doctor.profileUrl } }, [
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.doctor.name) +
                  ", " +
                  _vm._s(_vm.doctor.degrees) +
                  " \n                        "
              ),
              _c(
                "svg",
                {
                  attrs: {
                    width: "21",
                    height: "20",
                    viewBox: "0 0 21 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M11.4055 19.4304C10.9048 19.9311 10.0942 19.9347 9.58913 19.4385C9.0777 18.936 9.07405 18.1129 9.58103 17.606L15.894 11.293H0.167969V8.70964H15.894L9.58103 2.39665C9.07405 1.88968 9.0777 1.0666 9.58913 0.564134C10.0942 0.0679181 10.9048 0.0715049 11.4055 0.572171L20.8346 10.0013L11.4055 19.4304Z",
                      fill: "#2D8EFF"
                    }
                  })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.doctor.specialties
            ? _c("span", {
                staticClass: "item__specialties",
                domProps: { innerHTML: _vm._s(_vm.specialtyLabel) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getAffiliation
            ? _c("div", { staticClass: "item__affiliation" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "21",
                      height: "19",
                      viewBox: "0 0 21 19",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_1581_191860)" } },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M3.80335 8.87366C6.57482 8.87366 9.11589 7.68872 10.9657 5.74786V1.07617H4.69207V5.95897H0.03125V8.11094C1.19645 8.58083 2.4604 8.86685 3.79677 8.86685L3.80335 8.87366Z",
                            fill: "#671E75"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M10.9279 5.96579C9.59154 9.41167 6.60941 11.6386 2.90972 11.6386C1.88276 11.6386 0.888715 11.4615 0 11.1006V12.4626H4.69373V17.3454H10.9279V12.4626H15.5887V5.95898H10.9279V5.96579Z",
                            fill: "#671E75"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M10.7571 5.96531C9.83546 5.53628 8.84142 5.31836 7.80788 5.31836C6.7085 5.31836 5.64863 5.57033 4.6875 5.99936V8.8732C7.01791 8.62123 9.13766 7.57929 10.7505 5.96531H10.7571Z",
                            fill: "#BA9CC5"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M10.8955 6.0332C10.5532 6.85722 10.1451 7.64718 9.625 8.29414C12.1595 8.65507 14.3187 10.235 15.5498 12.4619C15.3457 9.91492 13.4629 7.29306 10.889 6.0332H10.8955Z",
                            fill: "#BA9CC5"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M0.03125 12.4961C1.30178 15.2269 4.04034 16.1939 7.02247 16.1939C8.42467 16.1939 9.79395 15.8739 10.9262 15.261V18.3527C9.89928 18.7818 8.73407 18.9997 7.53595 18.9997C3.21746 19.0337 0.413068 16.2689 0.03125 12.4961Z",
                            fill: "#BA9CC5"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M10.9297 5.99964C12.6084 4.05878 14.9388 2.83978 17.5062 2.83978C18.7372 2.83978 19.9024 3.12581 21.0018 3.62975V0.537993C20.1789 0.177061 19.2573 0 18.3291 0C15.0046 0 12.1278 2.40394 10.9626 5.78172L10.9297 5.99964Z",
                            fill: "#BA9CC5"
                          }
                        })
                      ]
                    ),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_1581_191860" } }, [
                        _c("rect", {
                          attrs: { width: "21", height: "19", fill: "white" }
                        })
                      ])
                    ])
                  ]
                ),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.getAffiliation) +
                    "\n                    "
                ),
                _c(
                  "button",
                  {
                    staticStyle: { display: "none" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.affiliationTooltip = !_vm.affiliationTooltip
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "11",
                          viewBox: "0 0 10 11",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M5 0.5C2.24 0.5 0 2.74 0 5.5C0 8.26 2.24 10.5 5 10.5C7.76 10.5 10 8.26 10 5.5C10 2.74 7.76 0.5 5 0.5ZM5.5 8H4.5V5H5.5V8ZM5.5 4H4.5V3H5.5V4Z",
                            fill: "black",
                            "fill-opacity": "0.5"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.affiliationTooltip
                  ? _c("div", { staticClass: "affiliation-tooltip" }, [
                      _c("p", [
                        _vm._v(
                          "CHRISTUS Trinity Clinic is a multi-specialty medical group offering in-person and virtual visit care options, with more than 1,200 clinicians representing over 250 locations serving Texas, Arkansas, and Louisiana"
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.doctor.ratings
          ? _c(
              "div",
              {
                staticClass: "c-provider-card__provider-ratings",
                attrs: { set: (_vm.rating = Number(_vm.doctor.ratings.rating)) }
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "c-provider-card__provider-ratings__percentage",
                    attrs: {
                      href: _vm.doctor.profileUrl + "#provider-reviews-section"
                    }
                  },
                  [_vm._v(_vm._s(_vm.rating))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-provider-card__provider-ratings__stars" },
                  [
                    _vm.rating == 0
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#FFFFFF",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _vm.rating > 0 && _vm.rating < 1
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "22",
                              height: "20",
                              viewBox: "0 0 22 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                fill: "white"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L11 6.92523L11 7.87539L11 12.4875V13.1515L11 15.9252Z",
                                fill: "#F8D76D"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#F8D76D",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        ),
                    _vm._v(" "),
                    _vm.rating <= 1
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#FFFFFF",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _vm.rating > 1 && _vm.rating < 2
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "22",
                              height: "20",
                              viewBox: "0 0 22 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                fill: "white"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L11 6.92523L11 7.87539L11 12.4875V13.1515L11 15.9252Z",
                                fill: "#F8D76D"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#F8D76D",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        ),
                    _vm._v(" "),
                    _vm.rating <= 2
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#FFFFFF",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _vm.rating > 2 && _vm.rating < 3
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "22",
                              height: "20",
                              viewBox: "0 0 22 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                fill: "white"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L11 6.92523L11 7.87539L11 12.4875V13.1515L11 15.9252Z",
                                fill: "#F8D76D"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#F8D76D",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        ),
                    _vm._v(" "),
                    _vm.rating <= 3
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#FFFFFF",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _vm.rating > 3 && _vm.rating < 4
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "22",
                              height: "20",
                              viewBox: "0 0 22 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                fill: "white"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L11 6.92523L11 7.87539L11 12.4875V13.1515L11 15.9252Z",
                                fill: "#F8D76D"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#F8D76D",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        ),
                    _vm._v(" "),
                    _vm.rating <= 4
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#FFFFFF",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _vm.rating > 4 && _vm.rating < 5
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              width: "22",
                              height: "20",
                              viewBox: "0 0 22 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                fill: "white"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L11 6.92523L11 7.87539L11 12.4875V13.1515L11 15.9252Z",
                                fill: "#F8D76D"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M11 15.9252L4.81966 19L6 12.4875L1 7.87539L7.90983 6.92523L11 1L14.0902 6.92523L21 7.87539L16 12.4875L17.1803 19L11 15.9252Z",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                      : _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "20",
                              viewBox: "0 0 21 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M10.5 15.9252L4.62868 19L5.75 12.4875L1 7.87539L7.56434 6.92523L10.5 1L13.4357 6.92523L20 7.87539L15.25 12.4875L16.3713 19L10.5 15.9252Z",
                                fill: "#F8D76D",
                                stroke: "#755A00",
                                "stroke-linejoin": "round"
                              }
                            })
                          ]
                        )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "c-provider-card__provider-ratings__count" },
                  [_vm._v(_vm._s(_vm.doctor.ratings.rating_count) + " ratings")]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "c-provider-card__provider-features" }, [
          _vm.doctor.acceptingNewPatients
            ? _c("span", { staticClass: "item__new" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "14",
                      viewBox: "0 0 18 14",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M11.4544 0.5C10.5866 0.5 9.75414 0.842535 9.14047 1.45196C8.5268 2.06138 8.18187 2.88806 8.18187 3.74985C8.18187 4.61163 8.5268 5.43832 9.14047 6.04774C9.75414 6.65716 10.5866 6.9997 11.4544 6.9997C12.3222 6.9997 13.1546 6.65716 13.7683 6.04774C14.382 5.43832 14.7269 4.61163 14.7269 3.74985C14.7269 2.88806 14.382 2.06138 13.7683 1.45196C13.1546 0.842535 12.3222 0.5 11.4544 0.5ZM11.4544 2.04383C11.6799 2.04383 11.9035 2.08801 12.1119 2.17394C12.3203 2.25988 12.5099 2.38515 12.6695 2.54371C12.8292 2.70227 12.956 2.89048 13.0419 3.09746C13.1284 3.30443 13.1729 3.52654 13.1729 3.75045C13.1729 3.97437 13.1284 4.19648 13.0419 4.40345C12.9553 4.61042 12.8292 4.79864 12.6695 4.95719C12.5099 5.11575 12.3203 5.24103 12.1119 5.32696C11.9035 5.4129 11.6799 5.45708 11.4544 5.45708C11.2289 5.45708 11.0052 5.4129 10.7968 5.32696C10.5884 5.24103 10.3989 5.11575 10.2392 4.95719C10.0796 4.79864 9.95281 4.61042 9.86688 4.40345C9.78034 4.19648 9.73586 3.97437 9.73586 3.75045C9.73586 3.29777 9.91685 2.86386 10.2392 2.54371C10.5616 2.22357 10.9985 2.04383 11.4544 2.04383ZM2.45468 2.93769V5.37538H0V7.0003H2.45468V9.43799H4.09094V7.0003H6.54562V5.37538H4.09094V2.93769H2.45468ZM11.4544 7.81246C9.26966 7.81246 4.90876 8.89332 4.90876 11.0623V13.5H17.9994V11.0623C17.9994 8.89272 13.6385 7.81246 11.4538 7.81246H11.4544ZM11.4544 9.35629C13.8847 9.35629 16.4454 10.5425 16.4454 11.0623V11.9562H6.46335V11.0623C6.46335 10.5425 8.9997 9.35629 11.4544 9.35629Z",
                        fill: "#333333"
                      }
                    })
                  ]
                ),
                _vm._v(
                  "\n                    Accepting new patients\n                "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.doctor.languages
            ? _c(
                "span",
                { staticClass: "item__idioms" },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "18",
                        viewBox: "0 0 20 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M12.0316 12.332V12.8043C12.0316 14.3548 10.8156 15.6178 9.33267 15.6178H5.27929L3.20316 17.7741C3.06476 17.9179 2.86703 18 2.67919 18C2.58033 18 2.49135 17.9795 2.39249 17.9384C2.11567 17.8152 1.93772 17.5379 1.93772 17.2299V15.5048C0.820564 15.1557 0 14.0776 0 12.8146V7.61894C0 6.06845 1.21602 4.81574 2.69896 4.81574H6.3569C6.76223 4.81574 7.09837 5.16486 7.09837 5.58585C7.09837 6.00684 6.76223 6.35596 6.3569 6.35596H2.69896C2.02669 6.35596 1.48295 6.92071 1.48295 7.61894V12.8146C1.48295 13.5026 2.02669 14.0776 2.68908 14.0776C3.09441 14.0776 3.42066 14.4267 3.42066 14.8477V15.3714L4.44884 14.3035C4.58725 14.1597 4.77509 14.0776 4.97281 14.0776H9.33267C10.0049 14.0776 10.5487 13.5128 10.5487 12.8043V12.332C10.5487 11.911 10.8848 11.5619 11.2902 11.5619C11.6955 11.5619 12.0316 11.911 12.0316 12.332ZM20 2.81346V8.00913C20 9.2721 19.1794 10.3605 18.0623 10.6994V12.4244C18.0623 12.7325 17.8843 13.02 17.6075 13.1329C17.5185 13.174 17.4197 13.1945 17.3208 13.1945C17.133 13.1945 16.9352 13.1124 16.7968 12.9686L14.7207 10.8123H10.5981C9.10529 10.8123 7.89916 9.54934 7.89916 7.99886V2.81346C7.89916 1.26298 9.11518 0 10.5981 0H17.2912C18.784 0 19.9901 1.26298 19.9901 2.81346H20ZM18.5171 2.81346C18.5171 2.11523 17.9733 1.54022 17.301 1.54022H10.608C9.93574 1.54022 9.39199 2.10496 9.39199 2.81346V8.00913C9.39199 8.70736 9.93574 9.28237 10.608 9.28237H15.0371C15.2348 9.28237 15.4226 9.36452 15.561 9.50827L16.5892 10.5762V10.0525C16.5892 9.63149 16.9155 9.28237 17.3208 9.28237C17.9832 9.28237 18.5269 8.70736 18.5269 8.01939V2.81346H18.5171ZM6.68314 7.17741L9.2437 13.1329H7.66189L6.89076 11.3873H5.11122L4.34009 13.1329H2.68908L5.31883 7.17741C5.43747 6.90017 5.7044 6.72561 5.9911 6.72561C6.27781 6.72561 6.54474 6.90017 6.66337 7.17741H6.68314ZM6.31735 10.073L6.01088 9.37479L5.7044 10.073H6.32724H6.31735ZM15.0173 6.14033C15.5709 5.46264 15.9664 4.83628 16.1938 4.43582H16.7771C16.8858 4.43582 16.9748 4.34341 16.9748 4.23046V3.10097C16.9748 2.98802 16.8858 2.89561 16.7771 2.89561H14.6911V1.74558H13.2081V2.89561H11.1221C11.0133 2.89561 10.9244 2.98802 10.9244 3.10097V4.23046C10.9244 4.34341 11.0133 4.43582 11.1221 4.43582H14.4241C14.2956 4.63092 14.1374 4.83628 13.9694 5.05191C13.8211 4.88762 13.7024 4.75414 13.6233 4.66172C13.564 4.58985 13.4652 4.56931 13.3861 4.60011L12.0811 5.08272L12.5358 5.68853C12.6644 5.85282 12.7929 6.00685 12.9313 6.17113C12.4765 6.59213 11.9723 7.00285 11.3791 7.3417L10.7365 7.72162L11.4582 9.06674L12.1008 8.68682C12.8127 8.2761 13.4256 7.78323 13.9595 7.29036C14.5428 7.83457 15.1656 8.31717 15.8082 8.68682L16.4508 9.06674L17.1725 7.72162L16.5299 7.3417C16.0455 7.06446 15.5116 6.6024 15.0272 6.14033H15.0173Z",
                          fill: "#333333"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.doctor.languages, function(language) {
                    return _c("span", { key: language }, [
                      _vm._v(_vm._s(language))
                    ])
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.doctor.ageGroupsSeen.length
            ? _c("span", { staticClass: "item__ages" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "19",
                      height: "19",
                      viewBox: "0 0 19 19",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d:
                          "M0 9C0 4.05 3.93 0 8.8 0C10.19 0 11.51 0.329998 12.68 0.919998C13.06 1.11 13.21 1.58001 13.02 1.96001C12.83 2.34001 12.36 2.49 11.98 2.3C11.02 1.82 9.94 1.55 8.79 1.55C4.8 1.55 1.53 4.87001 1.53 9.01001C1.53 13.15 4.8 16.47 8.79 16.47C12.78 16.47 16.05 13.15 16.05 9.01001C16.05 8.64001 16.03 8.29 15.98 7.94C15.92 7.52 16.22 7.13001 16.64 7.07001C17.06 7.01001 17.45 7.31001 17.51 7.73001C17.57 8.15001 17.6 8.58 17.6 9.02C17.6 13.97 13.67 18.02 8.8 18.02C3.93 18.02 0 13.97 0 9.02V9ZM17.76 1.15001C18.07 1.44001 18.09 1.93001 17.8 2.24001L9.06 11.59L5.83 8.41C5.53 8.11 5.52 7.62001 5.83 7.32001C6.13 7.02001 6.62 7.01001 6.92 7.32001L9.02 9.39L16.68 1.19C16.97 0.880002 17.46 0.860009 17.77 1.15001H17.76Z",
                        fill: "#333333"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.doctor.ageGroupsSeenLabel))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.doctor.allowsVirtualVisits
            ? _c("span", { staticClass: "item__virtual" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "20",
                      height: "13",
                      viewBox: "0 0 20 13",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M15.9897 5.3521V1.99796C15.9897 1.16757 15.0985 0.5 13.9846 0.5H2.00514C0.908312 0.5 0 1.16757 0 1.99796V11.002C0 11.8324 0.908312 12.5 2.00514 12.5H14.0017C15.0985 12.5 16.0069 11.8324 16.0069 11.002V7.6479L20 10.6275V2.37246L16.0069 5.3521H15.9897ZM13.9846 10.9858H2.00514V1.99796H14.0017V11.002L13.9846 10.9858ZM5.99829 4.99389C5.99829 4.1635 6.88946 3.49593 8.00343 3.49593C9.11739 3.49593 10.0086 4.1635 10.0086 4.99389C10.0086 5.82429 9.11739 6.49186 8.00343 6.49186C6.88946 6.49186 5.99829 5.82429 5.99829 4.99389ZM11.9794 9.48779H3.99314V9.06445C3.99314 8.77137 4.11311 8.47829 4.31877 8.23406C4.54156 7.98982 4.85004 7.79444 5.20994 7.68046C6.08398 7.38738 7.02656 7.24084 7.98629 7.24084C8.94602 7.24084 9.8886 7.38738 10.7626 7.68046C11.4996 7.92469 11.9794 8.46201 11.9794 9.06445V9.48779Z",
                        fill: "#333333"
                      }
                    })
                  ]
                ),
                _vm._v(
                  "\n                    Accepts virtual Visits\n                "
                )
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-provider-card__appointments" },
      [
        _c("LocationCard", {
          ref: "locationCard",
          attrs: {
            locations: this.doctor.locations,
            providerName: this.doctor.name
          },
          on: { selectedLocation: _vm.getProviderSlots }
        }),
        _vm._v(" "),
        !this.fetchingAppointments
          ? _c(
              "div",
              [
                _vm.scheduleDays && _vm.scheduleDays.length > 0
                  ? _c("ScheduleTable", {
                      attrs: {
                        scheduleDays: this.scheduleDays,
                        scheduleBaseUrl: this.doctor.scheduler_url,
                        providerId: this.doctor.sitecore_id,
                        locationId: this.selectedLocationId,
                        phone: this.doctor.phoneNumber
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                (!_vm.scheduleDays || _vm.scheduleDays.length == 0) &&
                this.doctor.show_scheduling_cta
                  ? _c("ScheduleCall", {
                      attrs: {
                        locations: this.doctor.locations,
                        phone: this.doctor.phoneNumber
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        this.fetchingAppointments
          ? _c("div", { staticClass: "c-provider-card__load-appointments" }, [
              _vm._v("\n            Loading Appointments...\n        ")
            ])
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-actions" }, [
      _c(
        "a",
        {
          staticClass: "btn-secondary has-arrow",
          attrs: { href: _vm.doctor.profileUrl }
        },
        [
          _vm._v("\n            View Provider Profile\n            "),
          _c(
            "svg",
            {
              attrs: {
                width: "19",
                height: "18",
                viewBox: "0 0 21 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M11.4055 19.4304C10.9048 19.9311 10.0942 19.9347 9.58913 19.4385C9.0777 18.936 9.07405 18.1129 9.58103 17.606L15.894 11.293H0.167969V8.70964H15.894L9.58103 2.39665C9.07405 1.88968 9.0777 1.0666 9.58913 0.564134C10.0942 0.0679181 10.9048 0.0715049 11.4055 0.572171L20.8346 10.0013L11.4055 19.4304Z",
                  fill: "#2D8EFF"
                }
              })
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7673cd88", { render: render, staticRenderFns: staticRenderFns })
  }
}